<template>
    <v-container class="wechat-card">
        <v-row style="margin-left:270px">
            <v-card height="350px" width="270px" v-for="card in items" :key="card.title" style="margin-right:30px;margin-top:20px">
                <v-img :src="card.src" size="64"></v-img>
                <v-card-title v-text="card.title"></v-card-title>
                <v-card-subtitle v-text="card.subtitle"></v-card-subtitle>
            </v-card>
        </v-row>
    </v-container>
</template>
<script>
    import ZHIFUBAO from "@/assets/imgs/qr/zhifubao.jpg"
    import WECHAT from "@/assets/imgs/qr/wechat.png"
    import WECHATFRIEND from "@/assets/imgs/qr/weixin.png"
    export default {
        data() {
            return{
                items:[
                    {
                        title:"支付宝打赏~",
                        src:ZHIFUBAO
                    },
                    {
                        title:"微信打赏~",
                        src:WECHAT
                    },
                    {
                        title:"微信扫一扫，加好友~",
                        src:WECHATFRIEND,
                        subtitle:"非诚勿扰，广告勿扰！"
                    },
                ],
            }
        }
    }
</script>
<style lang="stylus" scoped>
.wechat-card
  overflow  auto
  position relative
  top  0
  left 0
  width 100%
  height  100%
  background-position 20% bottom
  background-image url("../assets/imgs/bg/10.jpg")
</style>
